export class PoSearchDTO{
  public vendor_code?:string
  public poagreement_no?:string
  public plant?:string
  public document_date?:string
  public name1?:string
  public order_type?:string
  public status?:string
}
